export default "__VITE_ASSET__B2wo2esk__"